import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "backdrop", "panel"]
  static values = { open: Boolean }

  connect() {
    // INTENT: Set initial visibility state based on open value.
    // EXPECTED OUTCOME: Shows or hides modal elements depending on openValue.
    // CAVEAT/TRAP: Check target availability before toggling classes to prevent errors.
    this.updateVisibility()
  }

  openValueChanged() {
    // INTENT: React to programmatically updated open value attributes.
    // EXPECTED OUTCOME: Syncs DOM visibility with openValue state changes.
    // CAVEAT/TRAP: Automatic Stimulus value callbacks trigger on state changes.
    this.updateVisibility()
  }

  open() {
    // INTENT: Show the modal.
    // EXPECTED OUTCOME: Sets openValue to true.
    // CAVEAT/TRAP: Ensures external triggers can invoke open action cleanly.
    this.openValue = true
  }

  toggle() {
    // INTENT: Toggle modal visibility state.
    // EXPECTED OUTCOME: Flips openValue state.
    // CAVEAT/TRAP: Triggers openValueChanged callback.
    this.openValue = !this.openValue
  }

  close() {
    // INTENT: Hide the modal.
    // EXPECTED OUTCOME: Sets openValue to false.
    // CAVEAT/TRAP: Ensures backdrop click closes modal cleanly.
    this.openValue = false
  }

  updateVisibility() {
    if (this.hasContainerTarget) {
      this.containerTarget.classList.toggle("hidden", !this.openValue)
    }
  }
}
